import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter'
import {KeyOnlyFilterProvider} from '@github-ui/filter/providers'
import {FileIcon} from '@primer/octicons-react'

export class ShaFilterProvider extends KeyOnlyFilterProvider {
  constructor() {
    super(
      {
        displayName: 'Commit SHA',
        key: 'sha',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: FileIcon,
        description: 'Commit SHA',
      },
      {
        filterTypes: {
          exclusive: false,
          valueless: false,
          hasValue: false,
          multiKey: false,
          multiValue: false,
        },
      },
    )
  }
}
